module.exports = __webpack_public_path__ + "img/upload_bgc.c581ac6f.png";